import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CreditLimitContainerModel} from '../../../../../../models/aggregates/erp/credit';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';

@Injectable({providedIn: 'root'})
export class CreditLimitService extends BaseApiTemplateService<CreditLimitContainerModel> {

    constructor(http:HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/entity-credit-limits';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/entity-credit-limits';
        this.httpClient = http;
    }  
    
  
  }